import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/apiClient";
import { useAuth } from "./AuthContext";

const WaveContext = createContext(null);

export function WaveProvider({ children }) {
  const { user } = useAuth();
  const [waves, setWaves] = useState([]);
  const [currentWaveId, setCurrentWaveIdState] = useState(localStorage.getItem("current_wave_id") || "");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/waves");
      setWaves(data);
      const stored = localStorage.getItem("current_wave_id");
      const exists = data.find((w) => w.id === stored);
      let chosen;
      if (exists) {
        chosen = stored;
      } else {
        const cur = data.find((w) => w.is_current) || data[0];
        chosen = cur?.id || "";
      }
      if (chosen && chosen !== stored) {
        localStorage.setItem("current_wave_id", chosen);
      }
      setCurrentWaveIdState(chosen);
    } catch {
      // not authenticated probably; ignore
    } finally {
      setLoading(false);
    }
  }, []);

  // Refetch waves whenever the authenticated user becomes available (or changes).
  // This fixes the bug where opening the app right after login shows no waves
  // because the initial /waves request happened before auth cookies were set.
  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  const setCurrentWaveId = (wid) => {
    localStorage.setItem("current_wave_id", wid);
    setCurrentWaveIdState(wid);
    // Force a reload so all components refetch with new wave
    window.dispatchEvent(new CustomEvent("wave-changed", { detail: wid }));
  };

  const currentWave = waves.find((w) => w.id === currentWaveId) || null;

  return (
    <WaveContext.Provider value={{ waves, currentWave, currentWaveId, setCurrentWaveId, refresh, loading }}>
      {children}
    </WaveContext.Provider>
  );
}

export const useWaves = () => useContext(WaveContext);
